// Add to cart product from cutom button product link
document.addEventListener('click', async function (e) {

  const button = e.target.closest('.product_add_cart');
  if (!button) return;

  e.preventDefault();

  // Prevent double click
  if (button.getAttribute('aria-busy') === 'true') return;

  const productUrl = button.dataset.url;
  if (!productUrl) {
    console.error('Missing data-url');
    return;
  }

  try {

    // Start Impact loading animation
    button.setAttribute('aria-busy', 'true');

    const url = new URL(productUrl, window.location.origin);
    const handle = url.pathname.split('/products/')[1];

    const quantity = parseInt(url.searchParams.get('quantity')) || 1;
    const sellingPlan = url.searchParams.get('selling_plan');

    // 1️⃣ Get product
    const productRes = await fetch(`/products/${handle}.js`);
    const product = await productRes.json();

    const variant =
      product.variants.find(v => v.available) ||
      product.variants[0];

    // 2️⃣ Build payload
    const payload = {
      items: [{
        id: variant.id,
        quantity: quantity
      }]
    };

    if (sellingPlan) {
      payload.items[0].selling_plan = sellingPlan;
    }

    // 3️⃣ Add to cart
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    // 4️⃣ Refresh cart sections
    const sectionsRes = await fetch('/cart?sections=cart-drawer,header');
    const sections = await sectionsRes.json();

    if (sections['cart-drawer']) {
      const oldDrawer = document.getElementById('cart-drawer');
      if (oldDrawer) oldDrawer.outerHTML = sections['cart-drawer'];
    }

    if (sections['header']) {
      const header = document.querySelector('header');
      if (header) header.outerHTML = sections['header'];
    }

    // 5️⃣ Open drawer after DOM update
    requestAnimationFrame(() => {
      const newDrawer = document.getElementById('cart-drawer');
      if (newDrawer && typeof newDrawer.show === 'function') {
        newDrawer.show();
      }
    });

  } catch (error) {
    console.error('Cart error:', error);
  } finally {
    button.removeAttribute('aria-busy');
  }

});